<template>
  <footer>
    <div class="pull-left">
      <i class="far fa-copyright"></i> 2019 Papayum
    </div>
  </footer>
</template>

<script>
export default {
  name: 'shop-footer',
  methods: {
  }
}
</script>
<style lang="scss" scoped>
footer {
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/shop/Footer.vue